import moment from "moment";
import _ from "lodash";

export class Datoer {

    //offentlige metoder

    static datoMedKlokkeslett(dato: Date, klokkeslett: string): Date {
        var _klokkeslett = moment(klokkeslett, "HH:mm");
        var _dato = moment(dato)
            .hours(_klokkeslett.hours())
            .minutes(_klokkeslett.minutes())
            .toDate();
        return _dato;
    }

    static erGyldigDatoMedKlokkeslett(dato: Date, klokkeslett: string): boolean {
        return moment(klokkeslett, "HH:mm").isValid() &&
            moment(dato).isValid();
    }

    /** Sann dersom angitt dato er passert, dvs bakover i tid. */
    static erPassert(dato:Date){
        return dato.getTime() < new Date().getTime();
    }

    /** Datokonstant som representerer minste datoverdi, til bruk i feks i fra-til søk der fra skal være tilnærmet uendelig bakover i tid
     * Da vi antar at vi ikke har data tidligere enn 1970 brukes epoc 0 som verdi */
    static MIN_DATO: Date = new Date(0)

    /** Datokonstant som representerer største datoverdi, til bruk i feks i fra-til søk der fra skal være tilnærmet uendelig fremover i tid
     * no.systemfabrikken.lederplan.delt.Dato#maxZonedDateTime er definert som +33658-09-27T01:46:40Z
     * men dette er større en hva som er mulig å representere i javascripts Date */
    static MAX_DATO: Date = new Date('4000-01-01T12:00:00Z')
}

/** konverterer fra utc tid til lokal tid uten å hensynta tidssoneforskjell.
 * eks: tilLokalDatoIgnorerTs(new Date('2011-10-05T14:48:00.000Z')) = Wed Oct 05 2011 14:48:00 GMT+0200 (sentraleuropeisk sommertid) */
export function tilLokalDatoIgnorerTs(dato: Date):Date{
    if (_.isNil(dato)) return dato;
    return new Date(dato.getUTCFullYear(), dato.getUTCMonth(), dato.getUTCDate(), dato.getUTCHours(), dato.getUTCMinutes(), dato.getUTCSeconds(), dato.getUTCMilliseconds());
}

/** konverterer fra lokal tid til utc tid uten å hensynta tidssoneforskjell.
 * eks: tilUtcDatoIgnorerTs(new Date('2011-10-05T14:48:00.000+0300')) = Wed Oct 05 2011 14:48:00 GMT+0200 (sentraleuropeisk sommertid) */
export function tilUtcDatoIgnorerTs(dato: Date):Date{
    if (_.isNil(dato)) return dato;
    return new Date(Date.UTC(dato.getFullYear(), dato.getMonth(), dato.getDate(), dato.getHours(), dato.getMinutes(), dato.getSeconds(), dato.getMilliseconds()));
}

/** Returnerer første mandag i angitt uke / år. Klokkeslett satt til 12:00 i lokal ts */
export function mandagIUke(år:number, ukenummer: number): Date {
    //oppretter initiell dato med dag satt til 20.jan da isoWeek(..) gir feil år dersom initiell dato er i uke 53 ( moment(new Date("2021-01-02T00:00:00.000Z")).isoWeek() == 52 )
    return moment(new Date(år, 0, 20, 12, 0, 0, 0))
        .isoWeek(ukenummer)
        .isoWeekday(1)
        .toDate()
}

/** Returnerer angitt dato i UTC tid med klokkeslett satt til dagsslutt (23:59:..) uten at dato endres.
 * Eks 02.10.2021 23:40 i norsk tid (+1) blir til 02.10.2021 23:59:59.. i utc tid */
export function tilUTCSluttPåDagenUtenÅEndreDøgn(dato: Date): Date {
    return moment(dato).utc(true).endOf('day').toDate()
}

/** Returnerer klokkeslett i angitt dato i UTC tid formatert som HH:mm */
export function klokkeslettUTCTid(datoOgKlokkeslett:Date):string{
    if (_.isNil(datoOgKlokkeslett)) return null;
    return _.padStart(_.toString(datoOgKlokkeslett.getUTCHours()), 2, '0')+':'+_.padStart(_.toString(datoOgKlokkeslett.getUTCMinutes()), 2, '0');
}

/** Returnerer sann dersom angitt instans er en Date.
 * Returnerer usann dersom angitt dato er en Date med initialisert med ugyldig verdi (vises i konsole som 'Invalid Date') */
export function erGyldigDatoinstans(dato:Date){
    return _.isDate(dato) && !_.isNaN(dato.getTime())
}

export function minsteIkkeNullDato(...datoer: Date[]): Date {
    return new Date(Math.min(...datoer.filter(d => d != null).map(d => d.getTime())))
}

export function størsteIkkeNullDato(...datoer: Date[]): Date {
    return new Date(Math.max(...datoer.filter(d => d != null).map(d => d?.getTime())))
}

export function overlappendePeriode(a: { start: Date; slutt: Date }, b: { start: Date; slutt: Date }): boolean {
    if (a?.start == null || a?.slutt == null || b?.start == null || b?.slutt == null) return true;

    return (a.start.getTime() >= b.start.getTime() && a.start.getTime() <= b.slutt.getTime()) ||
        (a.slutt.getTime() >= b.start.getTime() && a.slutt.getTime() <= b.slutt.getTime());
}
